<div class="modal-header">
  <h4 class="modal-title">{{'header.menu.pdm_export' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
  <p>{{ 'chooseFinalizationPreselection.label' | translate }}</p>

    <div class="pb-2">
      <div class="mb-3 row mb-0">
        <label class="col-md-12 col-form-label font-weight-bold">{{'chooseFinalizationPreselection.label.type' | translate}}</label>
      </div>
      <div class="mb-3 row mb-0">
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.previous_value' | translate }}</span>
        <span class="col-form-label col-md-9">{{ oldData.classId ? oldData.classId : '' }}</span>
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.new_value' | translate}}</span>
        <span class="col-form-label col-md-9">{{ newData.classId }}</span>
      </div>
    </div>

    <div class="pb-2">
      <div class="mb-3 row mb-0">
        <label class="col-md-12 col-form-label font-weight-bold">{{'chooseFinalizationPreselection.label.main_description' | translate}}</label>
      </div>
      <div class="mb-3 row mb-0">
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.previous_value' | translate }}</span>
        <span class="col-form-label col-md-9">{{ oldNoteDisplayName }}</span>
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.new_value' | translate }}</span>
        <span class="col-form-label col-md-9">{{ newNoteDisplayName }}</span>
      </div>
    </div>

    <div class="pb-2">
      <div class="mb-3 row mb-0">
        <label class="col-md-12 col-form-label font-weight-bold">{{'chooseFinalizationPreselection.label.tarrif_no' | translate}}</label>
      </div>
      <div class="mb-3 row mb-0">
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.previous_value' | translate }}</span>
        <span class="col-form-label col-md-9">{{ oldData.customsTariffNumber ? oldData.customsTariffNumber : '' }}</span>
        <span class="col-form-label col-md-3">{{'chooseFinalizationPreselection.label.new_value' | translate }}</span>
        <span class="col-form-label col-md-9">{{ newData.customsTariffNumber }}</span>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-forward" (click)="selectPreselection(false)">
    {{'chooseFinalizationPreselection.button.use_previous_values' | translate}}
  </button>
  <button type="button" class="btn btn-primary btn-forward" (click)="selectPreselection(true)">
    {{'chooseFinalizationPreselection.button.use_new_values' | translate}}
  </button>
</div>
